module.exports = __webpack_public_path__ + "static/img/injuryBody3.272d7ea5.png";